// extracted by mini-css-extract-plugin
export default {"text":"Skeleton_text__XRkQj","pulse":"Skeleton_pulse__DM2ee","fill":"Skeleton_fill__VCboF","srOnly":"Skeleton_srOnly__IMqiF"};